document.addEventListener('DOMContentLoaded', function () {
  var layer = document.querySelector('.zendia-planet-card__space-layer');
  if (!layer) return;

  var comets = layer.querySelectorAll('.zendia-space-hero__comet');
  comets.forEach(function (comet, index) {
    var delay = (Math.random() * 4).toFixed(2) + 's';
    comet.style.animationDelay = delay;
    comet.style.animationDuration = index === 0 ? '15s' : '20s';
  });

  var probeOne = layer.querySelector('.zendia-planet-card__probe--one');
  if (probeOne) {
    probeOne.style.animationDelay = '3s';
  }

  var probeTwo = layer.querySelector('.zendia-planet-card__probe--two');
  if (probeTwo) {
    probeTwo.style.animationDelay = '8s';
  }

  var orbiter = layer.querySelector('.zendia-planet-card__orbiter');
  if (orbiter) {
    orbiter.style.animationDelay = '1.5s';
  }
});